<template>
    <a-layout class="main-layout">
        <global-header-default />
        <a-layout class="layout">
            <a-layout-content :style="{padding: 0, minHeight: '280px', background: '#fff'}">
                <a-page-header class="page-header icon" title="访问出错" @back="() => null">
                    <svg
                        class="icon"
                        aria-hidden="true"
                        slot="backIcon"
                        @click="$router.replace('/')"
                    >
                        <use xlink:href="#icon-icon_jinggaotishi" />
                    </svg>
                </a-page-header>

                <div class="main">
                    <h1>未找到您所访问的页面或内容</h1>

                    <a-button type="primary" @click="to_home">回到主页</a-button>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script>
export default {
    methods: {
        to_home() {
            window.location.href = "/";
        }
    }
};
</script>
<style lang="less" scoped>
.main-layout {
    overflow: hidden;
    height: 100%;

    .layout {
        background: #fff;
        top: 48px;
        position: absolute;
        width: 100%;
        bottom: 0;
        overflow: hidden;
    }
}
.layout-logo {
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
}
.layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}
.layout-footer-center {
    text-align: center;
}
.main {
    padding: 48px;
    h1 {
        font-size: 40px;
        margin-bottom: 24px;
    }
}
</style>